import CredentialFormScheme from "../entity/CredentialFormScheme";
import FTLSmartDetailDomainStore from "../../../FTLSmartDetailDomain/stores/FTLSmartDetailDomainStore";
import CredentialDetailRepository from "../../../../infrastructure/api/credentials/CredentialDetailRepository";
const props = {
    schema: CredentialFormScheme,
    repository: CredentialDetailRepository
};
const FTLCredentialDetailStore = FTLSmartDetailDomainStore(props);
export default FTLCredentialDetailStore;
//# sourceMappingURL=FTLCredentialDetailStore.js.map